import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { route } from 'src/app/app.route';
import { AppAuthService } from '../services/app-auth.service';
import { AppLogService } from '../services/app-log.service';
import { AppRouteService } from '../services/app-route.service';

@Injectable()
export class AppUserTypeGuard {
  private _authService = inject(AppAuthService);
  private _appRouteService = inject(AppRouteService);

  async canActivate(
    active: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    try {
      const user = await this._authService.currentUser();

      if (!user) {
        throw new Error('User Type Guard: Forbidden User');
      }

      if (active.data.userTypes) {
        const userType = await this._authService.userType();
        if (userType && active.data.userTypes.indexOf(userType) > -1) {
          return true;
        } else {
          this._appRouteService.navigate(`${route.home.path}`);
          throw new Error('User Type Guard: Forbidden User');
        }
      } else {
        return true;
      }
    } catch (error) {
      AppLogService.error(error);
      this._appRouteService.navigate(`${route.home.path}`, {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
  }
}
